export type FfmpegCoreUrls = {
  coreJsUrl: string
  coreWasmUrl: string
  coreWorkerUrl: string
}

export function getFfmpegCoreUrls(): FfmpegCoreUrls {
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : ''
  return {
    coreJsUrl: new URL('/ffmpeg/ffmpeg-core.js', origin).toString(),
    coreWasmUrl: new URL('/ffmpeg/ffmpeg-core.wasm', origin).toString(),
    coreWorkerUrl: new URL('/ffmpeg/ffmpeg-core.worker.js', origin).toString(),
  }
}
